import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../assets/images/closeIconModal.svg"
import CellTab from "../../../assets/images/Cell Tab.png"
import Timer from "../../../assets/images/timer.png"
import Warning from "../../../assets/images/warning-2.png"
import Refresh from "../../../assets/images/Refresh.png"
import Carried from "../../../assets/images/Carried.png"
import Customer from "../../../assets/images/Customer.png"
interface FindModalProps {
    show: boolean;
    onCloseClick: () => void;
    onSubmit: () => void;
    selectedAvailableReason: string; 
    setAvailableReason: React.Dispatch<React.SetStateAction<string>>; 
  }
  
  const FindModal: React.FC<FindModalProps> = ({ show, onCloseClick, onSubmit, selectedAvailableReason, setAvailableReason }) => {
    return (
      <Modal isOpen={show} centered className="reasonModl">
        <ModalBody className="modal_Body">
        <img
            data-testing-id="closeIcon"
            onClick={onCloseClick}
            className='closeIconModal'
            src={CLoseImg}
            alt=""
          />
          <div className="mainDv">
            <h1>Why could you not find it?</h1>
            <div className="allContent">
              {[
                { img: CellTab, label: "Out of stock" },
                { img: Refresh, label: "Out of season" },
                { img: Carried, label: "Not carried in the store" },
                { img: Customer, label: "Customer doesn't want it" },
                { img: Carried, label: "Other_" },
              ].map((reason, index) => (
                <div
                  key={index}
                  data-testing-id={"findItemDv_findModal" + index}
                  className={`contDv ${selectedAvailableReason === reason.label ? "selected" : ""}`}
                  onClick={() => setAvailableReason(reason.label)}
                >
                  <img src={reason.img} alt="" />
                  <h6>{reason.label}</h6>
                </div>
              ))}
            </div>
            <div className="btnDv">
              <button onClick={onSubmit} data-testing-id="submintBtn_findModal" disabled={!selectedAvailableReason}>Submit</button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  };
  

FindModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    
}  

export default FindModal;